import { render, staticRenderFns } from "./WhatsappDetail.vue?vue&type=template&id=3efb877d&scoped=true&"
import script from "./WhatsappDetail.vue?vue&type=script&lang=js&"
export * from "./WhatsappDetail.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappDetail.vue?vue&type=style&index=0&id=3efb877d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efb877d",
  null
  
)

export default component.exports